import * as Styled from './styles';
import { ContentContainerProps } from './types';

const ContentContainer = ({
  children,
  type,
  className,
  testID,
}: ContentContainerProps): JSX.Element => (
  <Styled.Content
    direction="column"
    align="center"
    fullWidth
    type={type}
    data-testid={testID}
    className={className}
  >
    {children}
  </Styled.Content>
);

export default ContentContainer;
